export const latlng = (obj) => new AMap.LngLat(obj.lng , obj.lat)

export const latlngsFrom = (arr) => arr.map( latlng )

export const boundsFrom = arr => new AMap.Bounds(...latlngsFrom(arr)) 